import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MAX_QUOTE_QUANTITIES } from "../../../constants/quoteQuantities";

const BomPageQuoteTable = (props) => {
  const [quotesQuantity, setQuotesQuantity] = useState([]);
  const [quotesResult, setQuotesResult] = useState([]);

  useEffect(() => {
    if (props?.bomDetails?.data?.result_price_and_coverage) {
      setQuotesQuantity(
        Object.keys(props.bomDetails?.data.result_price_and_coverage)
      );
      setQuotesResult(
        Object.values(props.bomDetails?.data.result_price_and_coverage)
      );
    }
  }, [props]);

  const quoteSlots = Array.from(
    { length: MAX_QUOTE_QUANTITIES },
    (_, index) => index
  );

  return (
    <div className="bomPageQuoteTable">
      <table className="bordered m-0">
        <thead>
          <tr>
            <th></th>
            {quoteSlots.map((index) => (
              <th key={index}>{`Quote ${index + 1}`}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="quantity">
            <td>Quantity</td>
            {quoteSlots.map((index) => (
              <td key={index}>{quotesQuantity[index] ?? "N/A"}</td>
            ))}
          </tr>
          <tr className="price">
            <td>Percentage</td>
            {quoteSlots.map((index) => (
              <td key={index}>
                {quotesResult[index]
                  ? quotesResult[index]?.percentage + "%"
                  : "N/A"}
              </td>
            ))}
          </tr>
          <tr className="price">
            <td>Total Price</td>
            {quoteSlots.map((index) => (
              <td key={index}>
                {quotesResult[index] ? "$" + quotesResult[index]?.total : "N/A"}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, {})(BomPageQuoteTable);
